module.exports = __webpack_public_path__ + "static/media/intro-bg.a7a148ba.svg";